import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        departments: '<',
        roles: '<',
        levels: '<',
        course: '<',
        exceptionTargets: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.close()"></button>
            <h2>{{ 'courses.Add people' | translate }}</h2>
        </div>
        <div class="modal-body">
            <form ng-submit="vm.filterEmployees()">
                <div class="form">
                    <div class="row">
                        <label class="label">{{ 'employee.Name' | translate }}</label>
                        <div class="items">
                            <input ng-model="vm.filter.name" type="text" class="form-control"
                             placeholder="{{ vm.$translate.instant('filter.Find an employee') }}">
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'courses.Department' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.departmentId"
                                    ng-options="dept.id as dept.value for dept in vm.departments">
                                <option value=""></option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'courses.Role' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.drlRoleId"
                                    ng-options="role.id as role.value for role in vm.roles">
                                <option value=""></option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'courses.Level' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.levelId"
                                    ng-options="level.id as level.value for level in vm.levels">
                                <option value=""></option>
                            </select>
                        </div>
                    </div>

                    <a class="btn main small btn-indented" ng-click="vm.filterEmployees()">{{ 'general.Search' | translate }}</a>
                </div>
            <form>
            <div class="well" ng-if="vm.isFiltered" ng-if="!vm.list.loading && vm.list.items.length">
                <list-empty ng-if="!vm.list.loading && !vm.list.items.length" list="vm.list" show-add-message="false"></list-empty>
                <table class="data01">
                    <thead>
                    <tr>
                        <th class="w1p nosort">
                            <input ng-click="vm.toggleAll()" ng-model="vm.checked" type="checkbox">
                        </th>
                        <th>{{ 'employee.First Name' | translate }}</th>
                        <th>{{ 'employee.Last Name' | translate }}</th>
                        <th>{{ 'employee.Position' | translate }}</th>
                        <th>{{ 'planning.Previous date completed' | translate }}</th>
                        <th>{{ 'planning.Personal deadline' | translate }}</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr ng-repeat="item in vm.list.items">
                            <td><input type="checkbox" ng-checked="vm.hasUser(item.id)" ng-click="$event.stopPropagation();vm.toggleUser(item.id)"></td>
                            <td>{{ item.firstName }}</td>
                            <td>{{ item.lastName }}</td>
                            <td>
                                <p ng-repeat="drl in item.drlsWithValue">{{ drl.departmentName }}, {{ drl.roleName }}, {{ drl.levelName }}</p>
                            </td>
                            <td>{{ item.previousPassedTime ? vm.MomentService.formatTimeStamp(item.previousPassedTime, 'DD.MM.YYYY') : '-' }}</td>
                            <td ng-bind-html="item.personalDeadline | personalDeadline: item.previousPassedTime:vm.isInfiniteDeadline"></td>
                        </tr>
                    </tbody>
                </table>
                <pagination list="vm.list"></pagination>
                <div ng-if="vm.userIds.length" class="form ng-scope">
                    <div class="row">
                        <label class="label">{{ 'employee.Participation' | translate }}</label>
                        <div class="items">
                            <ul class="checkboxes">
                                <li>
                                    <label ng-repeat="(value, label) in vm.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM.LABELS">
                                        <input ng-model="vm.type" value="{{ value }}" type="radio" name="r01"> {{ label }}
                                    </label>
                                 </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary" ng-if="vm.userIds.length">
                    <button class="btn main" type="button" ng-click="vm.save($event)">
                        {{ 'general.Add' | translate }}
                    </button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.close()">
                        {{ 'general.Cancel' | translate }}
                    </button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, $scope, lodash, UserResource, CourseResource, SiteService, TokenService, ListFactory,
                 MomentService, ROLE_COMPANY_MODULE_PRIVILEGE_ENUM, ROLE_CODE_ENUM, USER_STATUS_ENUM,
                 COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM, ROLE_PRIVILEGE_ENUM) {
        this.$translate = $translate;
        this.$scope = $scope;
        this.lodash = lodash;
        this.UserResource = UserResource;
        this.CourseResource = CourseResource;
        this.SiteService = SiteService;
        this.TokenService = TokenService;
        this.ListFactory = ListFactory;
        this.MomentService = MomentService;
        this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM = ROLE_COMPANY_MODULE_PRIVILEGE_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM = COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM;
        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;

        this.$scope.$watch('vm.list.loading', (newValue, oldValue) => {
            if (newValue !== oldValue && !this.list.loading) {
                this.assignDeadlines(this.list.items);
            }
        });
    }

    $onInit () {
        this.sites = this.SiteService.getSitesByPrivileges(
            [this.ROLE_PRIVILEGE_ENUM.KEYS.EMPLOYEE_VIEW, this.ROLE_PRIVILEGE_ENUM.KEYS.EMPLOYEE_MANAGE,
                this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_MANAGE, this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_ADMINISTRATE]
        );

        this.filter = {};
        this.defaultFilter = {
            siteIds: this.sites.length ? this.sites.map(site => site.id) : [-1],
            roleCode: this.ROLE_CODE_ENUM.KEYS.EMPLOYEE,
            statuses: [this.USER_STATUS_ENUM.KEYS.ACTIVE, this.USER_STATUS_ENUM.KEYS.NOT_STARTED],
            exceptionsCourseId: this.course.id,
            privilegesCheck: false
        };

        this.list = this.ListFactory.createWithPagination(this.UserResource.getUsers.bind(this.UserResource));
        this.isFiltered = false;
        this.userIds = [];
        this.type = this.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM.KEYS.COMPULSORY;
        this.isInfiniteDeadline = this.course.expirationMonths === null;
    }

    filterEmployees () {
        this.userIds = [];
        this.isFiltered = true;

        const filter = Object.assign({}, this.filter, this.defaultFilter);

        // If empty, don't include them in the filter (or set to undefined/null as API expects)
        if (!filter.departmentId) delete filter.departmentId;
        if (!filter.drlRoleId) delete filter.drlRoleId;
        if (!filter.levelId) delete filter.levelId;

        this.list.fetch(
            { expand: 'drlsWithValue,courseUsers' },
            filter
        );
    }

    assignDeadlines (users) {
        const outputModels = [];
        users.forEach((user) => {
            const courseUserFound = user.courseUsers.find((courseUser) => courseUser.courseId === this.course.id);
            if (courseUserFound) {
                user.personalDeadline = courseUserFound.deadline;
                user.previousPassedTime = courseUserFound.previousPassedTime;
            }
            outputModels.push(user);
        });
        this.list.items = outputModels;
    }

    hasUser (key) {
        return this.lodash.includes(this.userIds, key);
    }

    toggleUser (key) {
        if (this.hasUser(key)) {
            this.lodash.pull(this.userIds, key);
            this.checked = false;
        }
        else {
            this.userIds.push(key);
        }
    }

    toggleAll () {
        this.userIds = this.checked ? this.list.items.map((user) => user.id) : [];
    }

    save (event) {
        event.currentTarget.classList.add('loading');
        event.currentTarget.disabled = true;
        this.CourseResource.setTargetExceptions(
            { id: this.course.id },
            {
                userIds: this.userIds,
                type: this.type
            }
        ).$promise.then(() => {
            this.uibModalInstance.close();
        }).finally(() => {
            event.currentTarget.classList.remove('loading');
            event.currentTarget.disabled = false;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/target/exception/add/index.js